module.exports = __webpack_public_path__ + "static/img/feature_1.37036f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/feature_1.png
// module id = WbVO
// module chunks = 0